import React from "react";
import "../login/login.css";
import { useNavigate } from "react-router-dom";
import { LOGO } from "../../components/image";
import Loader from "../../components/Loader/Loader";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const handleSendOtp = () => {
    navigate("/verify-otp");
  };

  return (
    <>
      <div className="text-start ms-5 mt-5">
        <img src={LOGO} height={40} width={40} />
      </div>
      <div className="d-flex justify-content-center align-items-center full-height">
        <div className="login-box">
          <div className="text-start">Forgot Password?</div>

          <div className="d-flex align-items-center input-box">
            <input type="text" placeholder="Email" />
            <ion-icon name="mail-outline"></ion-icon>
          </div>

          <button className="btn-form mt-5" onClick={handleSendOtp}>
            Send Otp
          </button>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
